import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    html: {
        registration: "Inscription",
        login: "Connexion",
        userLink: "Utilisateur",
        profileLink: "<i class=\"fas fa-user fa-fw\"></i>&nbsp;Mon Compte",
        logoutLink: "<i class=\"fas fa-sign-out fa-fw\"></i>&nbsp;Se déconnecter"
    },
    login: {
        error: "Votre adresse mail n'est pas correcte.",
        loginError: "Votre code n'est pas correct.",
        noAccount: "Je n'ai pas de compte →",
        proRedirection: "Je suis un professionnel",
        patientRedirection: "Je suis un patient"
    },
    successRegistrationHTML: `
    <div class="success-text">
    <p>Vous avez été enregistré avec succès à l'application Activmed.</p>
    <p>Vous pouvez maintenant vous connecter à l'application pour prendre rendez-vous avec un professionnel en activité physique adaptée.</p>
    </div>
    `
};

export type _I18nNavHeader = typeof _fr;

const _en: _I18nNavHeader = {
    html: {
        registration: "Registration",
        login: "Login",
        userLink: "User",
        profileLink: "<i class=\"fas fa-user fa-fw\"></i>&nbsp;My account",
        logoutLink: "<i class=\"fas fa-sign-out fa-fw\"></i>&nbsp;Sign out"
    },
    login: {
        error: "Your login is not correct.",
        loginError: "Your code is not correct.",
        noAccount: "I am a simple user, and I don't have an account",
        proRedirection: "I am a professional",
        patientRedirection: "I am a patient"
    },
    successRegistrationHTML: `
    <div class="success-text">
    <p style="text-align: center">You have been successfully registered to the Activmed application.</p>
    <p style="text-align: center">You can now sign in the application to take appointment with a professional in Adapted Physical Activity (APA).</p>
    </div>
    `
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nNavHeader(lang?: string): _I18nNavHeader {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}